import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=bfa4bbd8&scoped=true&"
import script from "./newsCenter.js?vue&type=script&lang=js&"
export * from "./newsCenter.js?vue&type=script&lang=js&"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=bfa4bbd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa4bbd8",
  null
  
)

export default component.exports